import React, { useState } from 'react';
import { Modal, Form, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import SuccessModal from '../../../../components/SuccessModal/SuccessModal';
import FloatingLabel from '../../../../components/FloatingLabel/FloatingLabel';
import { CloseIcon } from '../../../../assets/icons';
import { verifyOldPassword, setNewPassword } from '../../../../services/AccountApi/profileApi';
import { toastNotify } from '../../../../utils/toastNotify';
import PasswordField from '../../../../components/SharedComponents/FormComponents/PasswordField';
import { sendVerificationLink } from '../../../../services/authApi/forgotPasswordApi';
import { removeCookie } from '../../../../utils/cookies';
import { resetUserData } from '../../../../store/reducer/accountSlice';
import { AES } from 'crypto-js'

const ChangePassword = (props) => {
  const { email, isPasswordSet } = props;
  const [password, setPassword] = useState();
  const [newPass, setNewPass] = useState();
  const [confNewPass, setConfNewPass] = useState();
  const [passwordNotMatchError, setPasswordNotMatchError] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);
  const [step, setStep] = useState('step1');
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const dispatch = useDispatch();

  let navigate = useNavigate();
  const handleFinishVerifyPassword = async (value) => {
    setLoading(true);
    try {
      const currentPassword = isPasswordSet ? AES.encrypt(value.currentPassword, process.env.REACT_APP_PASSWORD_ENCRYPT_KEY).toString() : '';
      const response = await verifyOldPassword({currentPassword});
      if (!response.isError) {
        setStep('step2');
      } else {
        toastNotify('error', response?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleChangePassword = async (values) => {
    if (values.newPassword === values.confnewpass) {
      //call api
      setLoading(true);
      const newPassord = {
        newPassword: AES.encrypt(values.newPassword, process.env.REACT_APP_PASSWORD_ENCRYPT_KEY).toString(),
      };
      try {
        const response = await setNewPassword(newPassord);
        if (!response.isError) {
          removeCookie();
          props.setClose();
          setSuccessOpen(true);
        } else {
          toastNotify('error', response?.message);
        }
      } catch (error) {
        const { response } = error;
        toastNotify('error', response?.data?.message);
      } finally {
        setLoading(false);
      }
    } else {
      setPasswordNotMatchError(true);
    }
  };

  const handleCloseSuccessModal = async () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.clear();
    setSuccessOpen(false);
    await dispatch(resetUserData());
    navigate('/login');
  };

  const handleRequestRestLink = async () => {
    let formData = {
      email: email,
      phoneNumber: null,
      credentialType: 'password',
    };
    setLoading(true);
    try {
      const userData = await sendVerificationLink(formData);
      if (!userData.isError) {
        toastNotify('success', 'Reset password link sent successfully');
        localStorage.clear();
        await dispatch(resetUserData());
        navigate('/login');
      } else {
        toastNotify('error', userData?.message);
      }
    } catch (error) {
      const { response } = error;
      response?.data?.message === 'Please enter a valid email and phone number' && toastNotify('error', 'No associated accounts');
      response?.data?.message !== 'Please enter a valid email and phone number' && toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal className='account__modal' open={props.setOpen} onCancel={props.setClose} width={524} footer={false} closeIcon={<CloseIcon />} centered>
        {step === 'step1' && (
          <>
            <h4 className='mb-32 account__modal__title'>{isPasswordSet ? 'Enter your current password' : 'Click Continue to set password'}</h4>
            <Form name='verify-password' onFinish={handleFinishVerifyPassword} autoComplete='off' form={form}>
              {isPasswordSet && <FloatingLabel label='Password' inputId='password' inputValue={password}>
                <PasswordField name={'currentPassword'} setPassword={(value) => setPassword(value)} password={password} validation={false}/>
              </FloatingLabel>}
              {!isPasswordSet && <Form.Item className='mb-0' shouldUpdate>
                {() => (
                  <Button
                    type='primary'
                    htmlType='submit'
                    className='w-100 mb-32'
                    loading={loading}
                  >
                    Continue
                  </Button>
                )}
              </Form.Item>}
              {isPasswordSet ?
                <p className={isPasswordSet && 'mb-32'}>
                  Forgot your password?{' '}
                  <span className='fw-600 cursor-pointer text-terracotta underline' onClick={handleRequestRestLink}>
                    Request reset link
                  </span>
                </p>
                : ''
              }
              {isPasswordSet && <Form.Item className='mb-0' shouldUpdate>
                {() => (
                  <Button
                    type='primary'
                    htmlType='submit'
                    className='w-100'
                    loading={loading}
                    disabled={!form.isFieldsTouched(true) || form.getFieldsError().filter(({ errors }) => errors.length).length > 0}
                  >
                    Continue
                  </Button>
                )}
              </Form.Item>}
            </Form>
          </>
        )}
        {step === 'step2' && (
          <>
            <h4 className='account__modal__title'>Enter your new password</h4>
            <p className='mb-32 text-taupe'>
              Your password must be 8 characters or more. Strong passwords include numbers, letters and punctuation marks.{' '}
            </p>
            <Form name='verify-password' onFinish={handleChangePassword} autoComplete='off' form={form}>
              <FloatingLabel label='New Password' inputId='newpassword' inputValue={newPass}>
                <PasswordField name={'newPassword'} setPassword={(value) => setNewPass(value)} password={password} />
              </FloatingLabel>
              <FloatingLabel className='mb-48' label='Re-enter new password' inputId='confnewpass' inputValue={confNewPass}>
                <PasswordField
                  // formInputClassName={"mb-48"}
                  name={'confnewpass'}
                  setPassword={(value) => {
                    setConfNewPass(value);
                    setPasswordNotMatchError(false);
                  }}
                  password={password}
                />
              </FloatingLabel>
              {passwordNotMatchError && (
                <p className='mb-48' style={{ color: 'red' }}>
                  {'Re-enter new password must be same as new password.'}
                </p>
              )}
              <Form.Item className='mb-0' shouldUpdate>
                {() => (
                  <Button
                    type='primary'
                    htmlType='submit'
                    className='w-100'
                    loading={loading}
                    disabled={!form.isFieldsTouched(true) || form.getFieldsError().filter(({ errors }) => errors.length).length > 0}
                  >
                    Reset password
                  </Button>
                )}
              </Form.Item>
            </Form>
          </>
        )}
      </Modal>
      <SuccessModal
        setOpen={successOpen}
        setClose={() => handleCloseSuccessModal()}
        setDone={() => {
          handleCloseSuccessModal();
        }}
      />
    </>
  );
};

export default ChangePassword;
